// components/BloodPressureForm.js
import React, { useState } from "react";
import { auth, db } from "../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";

export default function BloodPressureForm({ onSave }) {
  const [systolic, setSystolic] = useState("");
  const [diastolic, setDiastolic] = useState("");
  const [pulse, setPulse] = useState("");
  const [period, setPeriod] = useState("Morning"); // "Morning" | "Evening"
  const [dateTime, setDateTime] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (!user) return;

    try {
      // ✅ user-scoped path: /users/{uid}/bloodPressure/{autoDocId}
      const readingsRef = collection(db, "users", user.uid, "bloodPressure");
      await addDoc(readingsRef, {
        systolic: Number(systolic),
        diastolic: Number(diastolic),
        pulse: Number(pulse || 0),
        period,
        takenAt: dateTime
          ? Timestamp.fromDate(new Date(dateTime))
          : Timestamp.now(),
        createdAt: Timestamp.now(),
      });

      if (onSave) onSave();
      setSystolic("");
      setDiastolic("");
      setPulse("");
      setPeriod("Morning");
      setDateTime("");
    } catch (err) {
      console.error("[BP save] Firestore/App Check error:", err);
      alert("Could not save BP reading. See console for details.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="form-container">
      <input
        type="number"
        placeholder="Systolic"
        value={systolic}
        onChange={(e) => setSystolic(e.target.value)}
        required
      />
      <input
        type="number"
        placeholder="Diastolic"
        value={diastolic}
        onChange={(e) => setDiastolic(e.target.value)}
        required
      />
      <input
        type="number"
        placeholder="Pulse"
        value={pulse}
        onChange={(e) => setPulse(e.target.value)}
      />
      <select value={period} onChange={(e) => setPeriod(e.target.value)}>
        <option>Morning</option>
        <option>Evening</option>
      </select>
      <input
        type="datetime-local"
        value={dateTime}
        onChange={(e) => setDateTime(e.target.value)}
      />
      <button type="submit" className="save-btn">Save Reading</button>
    </form>
  );
}
